import React from 'react';

const BannerTeaching = (props) => (
    <section id="banner" className="style2 teaching major">
        <div className="inner">
            <header className="major">
                <h1>Teaching &amp; Events</h1>
            </header>
            <div className="content">
                <p>Classes I have taught and other activities</p>
            </div>
        </div>
    </section>
);

export default BannerTeaching;
